import moment from "moment";
import React, { Component } from "react";

class LogInfo extends Component {
  state = {};
  render() {
    return (
      <div className="log-info">
        <div>{`Originated By - ${this.props.createdBy} at ${moment(this.props.createdAt).format('lll')}`}</div>
        <div>{`Last Updated By - ${this.props.updatedBy} at ${moment(this.props.updatedAt).format('lll')}`}</div>
      </div>
    );
  }
}

export default LogInfo;



// WEBPACK FOOTER //
// ./src/utils/LogInfo.js